module.exports = __webpack_public_path__ + "static/media/demag50.3f11d654.pdf";